import { RootState } from "@app/lib/store";
import { PropertiesResponse } from "@app/type/property";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  propertiesData: [],
  locationData: {
    areaData: [],
    buildingData: [],
    communityData: [],
  },
  selectedProperty: {},
  relatedProperty: [],
  mapLocation: [],
};

export const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    setPropertiesData: (state, action: PayloadAction<PropertiesResponse>) => {
      state.propertiesData = action.payload.propertiesData;
      state.pagination = action.payload.pagination;
      if (action.payload?.page) state.page = action.payload.page;
    },
    setTopAreaData: (state, action: PayloadAction<any>) => {
      state.topAreaData = action.payload.TopAreaData;
    },
    setTopCommunityData: (state, action: PayloadAction<any>) => {
      state.topCommunityData = action.payload.TopCommunityData;
    },
    setTopPropertyData: (state, action: PayloadAction<any>) => {
      state.topPropertyData =
        action?.payload?.TopPropertyData || action?.payload || [];
    },
    setLocationData: (state, action: PayloadAction<any>) => {
      state.locationData = action.payload;
    },
    setSelectedProperty: (state, action: PayloadAction<any>) => {
      state.selectedProperty = action.payload;
    },
    setRelatedProperty: (state, action: PayloadAction<any>) => {
      state.relatedProperty = action.payload;
    },
    setPropertyDataOnly: (state, action: PayloadAction<PropertiesResponse>) => {
      state.propertiesData = action.payload;
      if (action.payload?.page) state.page = action.payload.page;
    },
    setMapLocation: (state, action: PayloadAction<PropertiesResponse>) => {
      state.mapLocation = action.payload;
    },
    setPage: (state, action: PayloadAction<any>) => {
      state.page = action.payload;
    },
  },
});

export const {
  setPropertiesData,
  setTopAreaData,
  setTopCommunityData,
  setTopPropertyData,
  setLocationData,
  setSelectedProperty,
  setRelatedProperty,
  setPropertyDataOnly,
  setMapLocation,
  setPage,
} = propertiesSlice.actions;

export const getProperties = (state: RootState) =>
  state.properties.propertiesData;

export const getPagination = (state: RootState) => state.properties.pagination;

export const getTopAreaData = (state: RootState) =>
  state.properties.topAreaData;

export const getTopCommunityData = (state: RootState) =>
  state.properties.topCommunityData;

export const getTopPropertyData = (state: RootState) =>
  state?.properties?.topPropertyData || [];

export const getLocationData = (state: RootState) =>
  state.properties.locationData;

export const getSelectedProperty = (state: RootState) =>
  state.properties.selectedProperty;

export const getRelatedProperty = (state: RootState) =>
  state.properties.relatedProperty;

export const getMapLocation = (state: RootState) =>
  state.properties.mapLocation;

export const getPageName = (state: RootState) => state.properties.page;

export default propertiesSlice.reducer;
